// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { TestCallDaten } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useStarteTestCall(): (
  requestBody: TestCallDaten
) => Promise<void> {
  const getAPI = useGetApi();
  return useCallback(
    async (requestBody) =>
      (await getAPI()).calls.starteTestCall({ requestBody }),
    [getAPI]
  );
}
